var _defs, _circle, _path, _path2, _path3, _rect, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guides",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#0090d0;stroke-width:2.7px;}.cls-3{stroke:#fff;stroke-width:9px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    cx: 60,
    cy: 60,
    r: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.05,1730.92a6.32,6.32,0,1,0-6.32-6.32A6.32,6.32,0,0,0,214.05,1730.92Zm0,3.16c-4.22,0-11.82,2.12-11.82,6.32v9.77h23.64v-9.77C225.87,1736.2,218.27,1734.08,214.05,1734.08Z",
    transform: "translate(-175.63 -1681.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.2,1730.92a6.32,6.32,0,1,0-6.32-6.32A6.32,6.32,0,0,0,257.2,1730.92Zm0,3.16c-4.22,0-11.82,2.12-11.82,6.32v9.77H269v-9.77C269,1736.2,261.42,1734.08,257.2,1734.08Z",
    transform: "translate(-175.63 -1681.17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.46,1742.06a8.41,8.41,0,1,0-8.41-8.41A8.4,8.4,0,0,0,235.46,1742.06Zm0,4.2c-5.61,0-15.71,2.82-15.71,8.41v13h31.43v-13C251.17,1749.08,241.07,1746.26,235.46,1746.26Z",
    transform: "translate(-175.63 -1681.17)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.78,
    y: 58.07,
    width: 15.05,
    height: 7.87
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.83,
    y: 58.07,
    width: 15.05,
    height: 7.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.46,1742.06a8.41,8.41,0,1,0-8.41-8.41A8.4,8.4,0,0,0,235.46,1742.06Zm0,4.2c-5.61,0-15.71,2.82-15.71,8.41v13h31.43v-13C251.17,1749.08,241.07,1746.26,235.46,1746.26Z",
    transform: "translate(-175.63 -1681.17)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.909673c72615f2f569bf99e9aab48a8e.svg";
export { ForwardRef as ReactComponent };